import { ReactNode } from 'react';

interface SettingsSectionProps {
}

const SettingsSection = ({ title, children, subtitle }: { title: string, children: ReactNode, subtitle?: string }) => {
  return (
    <div className={'w-full border-b border-slate-200 p-5 pt-8 pb-10 last:border-b-0'}>
      <div className={'max-w-xl w-full m-auto flex flex-col gap-6'}>
        <div>
          <h3 className={'font-semibold text-xl'}>{title}</h3>
          <p className={'text-slate-500'}>{subtitle}</p>
        </div>
        {children}
      </div>
    </div>
  );
};
export default SettingsSection;
